import React from 'react';
import { Field, reduxForm } from 'redux-form'
import { Button } from 'reactstrap';

import { renderField, renderSelect, renderRadio, validate, renderCheckBox } from '../../helpers/validation.helper';
import AutosuggestGEO from '../autosuggest/autosuggest.component';
import Uploader from '../../../SHARED/components/uploader/uploader.component';
import profileImg from '../../../FO/resources/img/user-icon-huge.png';

const RegisterForm = props => {
    const { handleSubmit, getDropdownValues, getMonths, getDays } = props;

    const dt = new Date();
    const currYear = dt.getFullYear();

    return (
        <div className="container register-page">
            <div className="row">
                <div className="col-lg-12 ">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-lg-12">
                                <Field
                                    id="lastName"
                                    name="lastName"
                                    type="text"
                                    placeholder="Nume"
                                    component={renderField}
                                />
                            </div>
                            <div className="col-lg-12">
                                <Field
                                    id="firstName"
                                    name="firstName"
                                    type="text"
                                    placeholder="Prenume"
                                    component={renderField}
                                />
                            </div>
                            <div className="col-lg-12">
                                <Field
                                    id="email"
                                    name="email"
                                    type="text"
                                    placeholder="Email"
                                    component={renderField}
                                />
                            </div>
                            <div className="col-lg-12">
                                <Field
                                    id="password"
                                    name="password"
                                    type="password"
                                    placeholder="Parola"
                                    component={renderField}
                                />
                            </div>
                            <div className="col-lg-12">
                                <Field
                                    id="passwordConfirm"
                                    name="passwordConfirm"
                                    type="password"
                                    placeholder="Confirmă parola"
                                    component={renderField}
                                />
                            </div>
                            <div className="col-lg-12">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <span className="dob-txt float-left db">Data nașterii</span>
                                    </div>
                                </div>

                                <Field
                                    className={'float-left'}
                                    name="month"
                                    component={renderSelect}>
                                    <option value="0">Luna</option>
                                    {getMonths()}
                                </Field>

                                <Field
                                    className={'float-left'}
                                    name="day"
                                    component={renderSelect}>
                                    <option value="0">Zi</option>
                                    {getDays()}
                                </Field>

                                <Field
                                    className={'float-left'}
                                    name="year"
                                    component={renderSelect}>
                                    <option>An</option>
                                    {getDropdownValues(1900, currYear)}
                                </Field>
                            </div>
                            <div className="col-lg-12">
                                <div className="checkboxes">
                                    <Field
                                        id="agreement"
                                        name="agreement"
                                        type="checkbox"
                                        label="Am citit termenii și condițiile și sunt de acord cu acestea"
                                        component={renderCheckBox}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-12 text-center">
                                <Button className="btn-cinemap-blue register-user" type="submit">Înregistrare</Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )

};

export default reduxForm({
    form: 'registerForm', // a unique identifier for this form,
    validate: validate('registerForm')
})(RegisterForm)



// WEBPACK FOOTER //
// ./src/SHARED/components/register/registerForm.js